import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { createPhoneMask } from "./model";
import { FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { VuiValidators } from "../directives/mat-input-required.directive";
import { FloatLabelType } from "@angular/material/form-field";

@Component({
    selector: "vui-phone-form-field",
    templateUrl: "./phone-form-field.component.html",
})
export class PhoneFormFieldComponent implements OnInit, OnDestroy {
    private _unsubscribeAll = new Subject();

    @Input()
    label: string;

    @Input()
    placeholder: string;

    @Input()
    form: FormGroup;

    @Input()
    controlName: string;

    @Input()
    phoneMask = createPhoneMask();

    required: boolean;

    @Input()
    classes: string[] = [];

    @Input()
    floatLabel: FloatLabelType = "auto";

    constructor() {}

    ngOnInit(): void {
        this.required =
            this.form.get(this.controlName).hasValidator(Validators.required) ||
            this.form.get(this.controlName).hasValidator(VuiValidators.required);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
